<label class="file-input__label">
    <input type="file" id="attachment-file" name="attachmentFile" (change)="onFileChange($event)" />
    <span class="file-input__input"></span>
</label>

<span *ngIf="currentFileName" class="file-input__name">{{ currentFileName }}</span>
